var _defs, _path, _text, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconsCtrlKey(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.93 52.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #202346;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        font-family: IBMPlexSans-Bold, 'IBM Plex Sans';\n        font-size: 8.89px;\n        font-weight: 700;\n      }\n\n      .cls-3 {\n        fill: #d3343f;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m47.52,33.99v-15.05c0-1.66-1.34-3-3-3H8.41c-1.66,0-3,1.34-3,3v15.05c0,1.66,1.34,3,3,3h36.11c1.66,0,3-1.34,3-3Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(9.85 26.79)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CTRL"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.52,33.99v-15.05c0-1.66-1.34-3-3-3H8.41c-1.66,0-3,1.34-3,3v15.05c0,1.66,1.34,3,3,3h36.11c1.66,0,3-1.34,3-3Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconsCtrlKey);
export default __webpack_public_path__ + "static/media/help_icons_ctrl_key.17970f53c6ff3af07998ddce756543b6.svg";
export { ForwardRef as ReactComponent };